import { createFileRoute, Navigate } from '@tanstack/react-router'

// v1 の /t/$tenant_id/shearing_certificates/upload を、PDF統一アップロード画面へのリダイレクトとして残す
// （旧URLを踏んだブックマーク・外部リンクが迷子にならないようにするため）
export const Route = createFileRoute('/t/$tenant_id/shearing_certificates/upload')({
  component: RedirectToUpload,
})

function RedirectToUpload() {
  const { tenant_id: tenantId } = Route.useParams()
  return <Navigate to="/t/$tenant_id/upload" params={{ tenant_id: tenantId }} replace />
}
